'use strict';

angular.module('ringbaPortal').component('targetStatus', {
  bindings: {
    target: '<',
    overrideBlockReasonTranslations: '<'
  },
  controller: TargetStatusController,
  controllerAs: 'vm',
  templateUrl: '/scripts/shared/components/target-stats/target-status.view.html'
});

function TargetStatusController(
  targetService,
  statsService
) {
  'ngInject';

  const vm = this;

  vm.getClass = getClass;
  vm.getStatus = getStatus;

  function getClass() {
    if (vm.target) {
      if (vm.target.tStatus && vm.target.tStatus.uiStatus) {
        return vm.target.tStatus.uiStatus.className;
      }
      return statsService.checkBlockReason(vm.target, targetService.blockReasonTranslation).className;
    }
  }

  function getStatus() {
    if (vm.target) {
      if (vm.target.tStatus && vm.target.tStatus.uiStatus) {
        return vm.target.tStatus.uiStatus.tooltip;
      }
      return statsService.checkBlockReason(vm.target, targetService.blockReasonTranslation).tooltip;
    }
  }
}
